"use client";
import styles from './ColorPicker.module.scss';
import React, { Suspense} from 'react';
import ColorButton from '../ColorSwitchButton';
import Text from '@components/atoms/Text';
import { cn } from '@utils/utils';

interface Color {
  id: string;
  brand_color: string;
  // hexCodes: string[];
  base_colors_hexcodes: string[];
  name: string;
  type:string;
}

interface ColorPickerProps {
    colors: Color[];
    selectedColor: Color;
    brandName?: string;
    modelName?: string;
    variantName?: string;
    pageType?:string;
    isSellable?: boolean;
    carAvailability?: string;
    colorButtonClassname?: string
    colorListItemClassname?: string
}

const ColorPicker: React.FC<ColorPickerProps> = ({
    colors,
    selectedColor,
    brandName,
    modelName,
    variantName,
    pageType,
    isSellable,
    carAvailability,
    colorButtonClassname = "",
    colorListItemClassname = ""
}) => {
    return (
      <>
        <div className={styles.colorSection}>
          <Text level="p" className={styles.colorTitle}>
            {colors?.find((c) => c.id === selectedColor?.id)?.brand_color}
          </Text>
          <div className={styles["colors__hero-available-colors-list"]}>
            {colors?.map((color) => (
              <li
                className={cn(styles["colors__hero-available-colors-list-item-button"], colorListItemClassname)}
                key={color.id}
              >
                <Suspense fallback={null}>
                  <ColorButton
                    color={{
                      name: color.brand_color,
                      color: color.base_colors_hexcodes,
                      type: color.type,
                    }}
                    isActive={color.id === selectedColor?.id}
                    isVariant={true}
                    brandName={brandName}
                    modelName={modelName}
                    variantName={variantName}
                    pageType={pageType}
                    carAvailability={carAvailability}
                    isSellable={isSellable}
                    colorButtonClassname={colorButtonClassname}
                  />
                </Suspense>
              </li>
            ))}
          </div>
        </div>
      </>
    );
};

export default ColorPicker;